import * as actions from './actions';
import getters from './getters';
import mutations from './mutations';

import google_actions from "./google/actions";
import google_getters from "./google/getters";
import google_mutations from "./google/mutations";

import * as quote_actions from './quotes/actions';
import quote_getters from "./quotes/getters";
import quote_mutations from "./quotes/mutations";
import moment from "@/moment-gp";

function initialState() {
  return {
    /* events */
    events: [], /* user created calendar events = sessions */
    markers: [],
    default_markers: [],
    initial_data_ready: false,

    /* google */
    google_is_signed_in: false,
    google_eventlist: [],
    google_authorized: 0,
    google_auth_date: null,

    /* quotes and idols */
    idols: [],
    idols_last_update: null,

    /* drag and drop */
    is_dragging: false,
    current_drop_zone: null,

    /* view settings */
    calendar_view_settings: {
      view: 'agenda', /* agenda, list, agendaWeek */
      timeslotDuration: '00:30:00', /* = zoom */
      show_now_indicator: true,
      visible_range: {
        from_date: moment.currentTime().subtract(0,'days').toStore(),
        to_date:   moment.currentTime().add(7, 'days').toStore(),
        /* Why do we save the information twice?
           It's easier when we rehydrate the store, but the date has changed */
        horizon:   7
      },
      visible_time: {
        min_time: 5,
        max_time: 24
      },
      source: {
        optimizer: false,
        user: false,
        tsc: true,
        _stacking: true
      }
    },

    /* selection (TODO: move to user?) */
    timeslot_collection_selected: null,
    goal_selected: null,
    effort_selected: null,
  }
};

const store = {
  namespaced: true,
  state: initialState(),
  getters: {
    ...getters,
    ...google_getters,
    ...quote_getters
  },
  mutations: {
    ...mutations,
    ...google_mutations,
    ...quote_mutations,
    RESET(state) {
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
  },
  actions: {
    ...actions,
    ...google_actions,
    ...quote_actions
  }
};

export default store;
